module.exports = __webpack_public_path__ + "img/3.ca390213.png";